var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"i_btn",class:{disabled_btn: _vm.disabled, heat_beat: _vm.heatBeat},style:(_vm.style),attrs:{"disabled":_vm.disabled},on:{"click":_vm.clickHandle}},[_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }